export const GET_SSH_KEY_LOADING = 'GET_SSH_KEY_LOADING';
export const GET_SSH_KEY_COMPLETE = 'GET_SSH_KEY_COMPLETE';
export const GET_SSH_KEY_ERROR = 'GET_SSH_KEY_ERROR';
export const CREATE_SSH_KEY_LOADING = 'CREATE_SSH_KEY_LOADING';
export const CREATE_SSH_KEY_COMPLETE = 'CREATE_SSH_KEY_COMPLETE';
export const CREATE_SSH_KEY_ERROR = 'CREATE_SSH_KEY_ERROR';
export const DELETE_SSH_KEY_LOADING = 'DELETE_SSH_KEY_LOADING';
export const DELETE_SSH_KEY_COMPLETE = 'DELETE_SSH_KEY_COMPLETE';
export const DELETE_SSH_KEY_ERROR = 'DELETE_SSH_KEY_ERROR';
